import { Icon } from '@centivo/react-components'
import React from 'react'
import styled from 'styled-components'

const CalloutContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
`

const Callout = styled.div<{ width: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  background-color: #f0f5ff;
  margin: 1rem 0;
  padding: 0.75rem;
  border-radius: 4px;
  color: #444;
  font-weight: 600;
  width: ${props => props.width};

  svg {
    height: 1.5rem;
    width: 1.5rem;
    margin-right: 0.75rem;
    color: #5586ef;
  }
`
/** Remove SearchCallout after prod is stabilized */
export const SearchCallout: React.FC<{ width?: string }> = ({
  width = '100%',
}) => {
  return (
    <CalloutContainer>
      <Callout width={width}>
        <Icon icon="fill-info-circle" />
        This directory search is current as of May 31, 2023. Please log into the
        member portal to browse latest in-network providers.
      </Callout>
    </CalloutContainer>
  )
}
